<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import Cookies from "js-cookie";

export default {
  name: 'App',
  mounted() {
    // 应用启动时清理无效的userToken
    this.cleanInvalidToken();
    // 添加beforeunload事件监听器，当浏览器关闭页面时清除cookie
    window.addEventListener('beforeunload', this.clearCookieOnUnload);
  },
  beforeDestroy() {
    // 组件销毁时移除事件监听器
    window.removeEventListener('beforeunload', this.clearCookieOnUnload);
  },
  methods: {
    cleanInvalidToken() {
      // 清理无效的userToken（undefined或null）
      let token = Cookies.get('userToken');
      if (token === 'undefined' || token === 'null' || !token) {
        Cookies.remove('userToken');
        Cookies.remove('userInfo');
        localStorage.removeItem('userData');
      }
    },
    clearCookieOnUnload() {
      // 清除认证相关的cookie和本地存储
      Cookies.remove("userInfo");
      Cookies.remove("userToken");
      localStorage.removeItem("userData");
    }
  }
}
</script>

<style lang="scss">
#app{
  width: 100%;
  height: 100%;
}
::-webkit-scrollbar{
  width: 6px;
  /*
  background: linear-gradient( 270deg, #0F87FA 0%, rgba(0,192,254,0.99) 100%);
  border-radius: 3px; */
  opacity: 0.0;
}
::-webkit-scrollbar-thumb {
    width: 6px;
    background: linear-gradient( 270deg, rgb(15, 135, 250,0.4) 0%, rgba(0,192,254,0.4) 100%);
    border-radius: 3px;
    opacity: 0.4;
}
::-webkit-scrollbar-track {
  -webkit-box-shadow: 0;
  border-radius: 0;
  opacity: 0.4;
}  

</style>
